<template>
	<div>
		<div class="header-container">
			<div class="back-button" @click="gotoLogin()">&lt;</div>
			<div class="login_header" @click="gotoLogin()">找回密码</div>
		</div>
		<div class="login" :style="{backgroundImage:'url('+loginBgImg+')'}">
			<!-- <div class="top-bg" :style="{backgroundImage:'url('+topImage+')'}"></div> -->
			<div class="login-type-content">
				<div class="login-bg-div" style="text-align: center;">
					<!-- <img src="../assets/registerLogo.png" class="logoimg"> -->
				</div>
				<div class="main_content">
					<div class="login-type-form">
						<div class="item_title" style="">会员编号</div>
						<div class="cu-form-group inpStyle" style="">
							<el-input placeholder="输入会员编号" type="text" v-model="loginPass.mb_no" minlength="20" @input="validPwdNull"
								maxlength="20" name="lgoinId"></el-input>
						</div>
						<div class="item_title">手机号码</div>
						<div class="cu-form-group inpStyle" style="">
							<el-input type="number" placeholder="输入手机号码" v-model="loginPass.mobile_no" @input="validPwdNull"
								maxlength="11">
							</el-input>
						</div>
						<div class="confirm_div">
							<el-button class="findpwd_btn" @click="sendPwd" :disabled="isComplete == false">确定</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { requestApi, checkMobileNo } from '@/utils/request';
import { MessageBox } from 'element-ui';
export default {
	computed: {
		isComplete() {
			return this.loginPass.mb_no != "" && this.loginPass.mobile_no != "";
		}
	},
	data() {
		return {
			loginBgImg: 'https://prodcdn.shaklee.com.cn/shaklee/upload/register-bg01.png',
			pwdNull: true,
			loginPass: {
				// mb_no: 'E01158',
				mb_no: '',
				mobile_no: ''
			},
			isProcessing: false,
			loadingInstance: null,
			bindErrMsg: "会员编号与手机号绑定关系有误，请确认",
			successMsg: "您的密码已经通过短信形式发送到手机，请查收",
		};
	},
	onLoad() {
	},
	methods: {
		gotoLogin() {
			this.$router.push({ path: '/' })
		},
		// 密码登录按钮是否禁用
		validPwdNull() {
			this.pwdNull = true
			if (this.loginPass.mb_no && this.loginPass.mobile_no) {
				this.pwdNull = false
			}
		},
		checkMbNo(input) {
			if (input.length < 5) {
				return false;
			}
			// 检查是否纯数字
			if (/^\d+$/.test(input)) {
				return true;
			}

			// 检查是否以字母 E 开头
			if (/^[A-Z]\d*$/.test(input)) {
				return true;
			}

			// 如果都不符合，返回 false
			return false;
		},
		showLoadingBox() {
			this.loadingInstance = this.$loading({
				lock: true,
				body: true,
				text: '网络请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.6)',
				target: document.body,
				customClass: ' sk-loading-class'
			});
		},
		closeLoadingBox() {
			this.loadingInstance.close();
		},
		// 找回密码
		sendPwd() {
			console.log(this.isProcessing);
			if (this.isProcessing) {
				console.log("sendPwd is working");
				return false;
			}
			this.isProcessing = true;
			if (this.loginPass.mb_no === "") {
				this.$message({
					type: 'info',
					message: '请输入会员编号',
					duration: 1000
				});
				this.isProcessing = false;
				return false;
			} else if (!this.checkMbNo(this.loginPass.mb_no)) {
				this.$message({
					type: 'info',
					message: '请填写正确的会员编号',
					duration: 1000
				});
				this.isProcessing = false;
				return false;
			} else if (this.loginPass.mobile_no === "") {
				this.$message({
					type: 'info',
					message: '请输入手机号',
					duration: 1000
				});
				this.isProcessing = false;
				return false
			} else if (!checkMobileNo(this.loginPass.mobile_no)) {
				this.$message({
					type: 'info',
					message: '请输入正确的手机号码',
					duration: 1000
				});
				this.isProcessing = false;
				return false
			} else {
				var mbNo= this.loginPass.mb_no;
				mbNo = mbNo.replace(/\s/g, '');
				this.loginPass.mb_no = mbNo; 
				const requestInfo = {
					"mb_no": mbNo,
					"mobile_no": this.loginPass.mobile_no
				}
				this.showLoadingBox();
				const funUrl = "/member/retrieve_pwd";
				requestApi(funUrl, requestInfo, 1)
					.then((respData) => {
						this.isProcessing = false;
						this.closeLoadingBox();
						if (respData && respData.code == 0) {
							console.log('retrieve_pwd' + respData.code);
							// this.$message({
							// 	type: 'info',
							// 	message: this.successMsg,
							// 	duration: 3000
							// });
							MessageBox.alert(this.successMsg, '提示', {
								customClass: 'lf-message-box'
							}).then(() => {
								this.gotoLogin();
							});
							return true;
						} else {
							console.log('retrieve_pwd' + respData.message);
							this.bindErrMsg = respData.message;
							MessageBox.alert(this.bindErrMsg, '提示', {
								customClass: 'lf-message-box'
							}).then(() => {

							});
							return false;
						}
					})
					.catch(error => {
						this.closeLoadingBox();
						return;
					});
			}
		},
	}
};
</script>
<style lang="scss">
.header-container {
	display: flex;
	align-items: center;
	background: #f1f3f4;
	position: fixed;
	z-index: 999;
	width: 100%;
	padding-top: 1.4em;
	padding-bottom: 5px;
	box-sizing: border-box; /* 确保内边距不会影响宽度 */
  }
  
  .back-button {
	font-size: 20px;
	font-weight: 600;
	color: #014134;
	margin-left: 5%; /* 右边距，使标题与按钮之间有一定的间距 */
  }

.login_header {
	background: #f1f3f4;
	text-align: left;
	line-height: 14px;
	font-weight: 600;
	color: #014134;
	font-size: 20px;
	margin-left: auto; /* 使标题向右推 */
	margin-right: auto; /* 使标题向左推 */
	padding-right: 10%;
}

.logo {
	width: 100px;
	height: 25px;
	padding-left: 35%;
	padding-top: 10px;
	position: fixed;
}

.logoimg {
	width: 100px;
	height: 25px;
	padding-top: 10px;
}

.login {
	width: 100%;
	height: 100vh;
	overflow: auto;
	font-family: pingfang;
	//background-size: cover;
	background-size: 100% 100%;
	//background-position: 20% 90%;
	//background-position: calc(20% + 2px) calc(87% - 2px);
	background-attachment: fixed;
	/* 背景图片固定在视口中 */
	min-width: 350px;
	min-height: 100vh;
	position: relative;

	.el-input__inner {
		width: 99%;
		border: none;
		height: 2.50rem;
		line-height: 3.0rem;
		border-radius: 2.5rem;
		margin-top: 10px;
		color: black;
	}

	.item_title {
		font-size: 14px;
		color: #000;
		margin-top: 25px;
		margin-left: 5%;
		text-align: left;
	}

	.login-type-content {
		position: absolute;
		/*参照物是父容器*/
		top: 12rem;
		/* 参照物是父容器 */
		transform: translateY(-45%);
		/*百分比的参照物是自身 */
		margin: 0px 5%;
		z-index: 9;
		// background-color: #fff;
		border-radius: 30upx;

		.login-bg-div {
			width: 90vw;
			// margin: 0px 5%;
		}

		.main_content {
			// margin: 0px 5%;
			padding-bottom: 30px;
			width: 94%;
			padding-left: 10%;

			.findpwd_btn {
				margin-top: 1.5rem;
				margin-bottom: 1rem;
				width: 98%;
				height: 40px;
				border-radius: 25px;
				border: none;
				background-color: #173f35;
				color: #fff;
			}
			.findpwd_btn:disabled {
				background-color: #909399;
				color: white;
				cursor: not-allowed;
				opacity: 0.7;
			}

			.nav-bar {
				display: flex;
				height: 100rpx;
				justify-content: center;
				align-items: center;
				position: relative;
				z-index: 10;
				margin-top: 60px;

				.nav-bar-item {
					flex: 1;
					display: flex;
					height: 100%;
					line-height: 130rpx;
					font-size: 18px;
					font-weight: 600;
					// display: flex;
					color: #aaa;
					margin: 0px 0px 0px 30px;
					justify-content: left;
				}

				// .nav-bar-item-active {
				// 	border-bottom: 5rpx solid;
				// }
			}

			.login-type-form {
				width: 86%;
				margin: 30rpx auto;
				margin-top: 10%;
			}

			.login-type-tips {
				padding: 0 50rpx;
				display: flex;
				justify-content: space-between;
				font-size: 28upx;
				color: #666;
			}
		}
	}
}

.uni-input-placeholder {
	padding-left: 10px !important;
}

.cu-form-group input {
	padding-left: 42rpx !important;
	font-size: 24rpx !important;
	color: #2c2c2c !important;
	font-weight: 500 !important;
}

.inpStyle {
	border-radius: 25px;
}

.el-message {
	background-color: #003300;
	/* 背景颜色 */
	border-radius: 8px;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	left: 50% !important;
	top: 20% !important;
	max-width: 100%;
	min-width: unset !important;
	padding-left: 7px !important;
	padding-right: 7px !important;
}

/* 自定义消息文本样式 */
.el-message__content {
	font-size: 12px;
	/* 字体大小 */
	/* 文字颜色 */
	color: white !important;
}

.el-message__icon {
	display: none !important;
}

/* 调整大小 */
.lf-message-box.el-message-box {
	width: 80%;
	text-align: center;
}

.el-button.el-button--primary {
	color: #fff;
	background-color: #173f35;
	border-color: #173f35;
}

/* 调整位置 */
.lf-message-box.el-message-box__wrapper {
	left: 50% !important;
	top: 50% !important;
	transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/page/loginForget.vue